<template>
  <div class="mb-20">
    <section v-if="!isFailed">
      <div class="flex justify-between items-center text-xs tracking-widest" >
        <h2 class="uppercase font-semibold pt-1">
          {{ $t('order.details') }}
        </h2>
        <a class="px-3 capitalize py-1 bg-black text-white font-bold"
          v-if="order.invoice_url"
          :href="order.invoice_url">
          {{ $t('order.invoice-link') }}
        </a>
      </div>
      <section class="italic text-xs text-b2c-grey-200 pt-1" v-if="isPending">
        {{ $t('order.waitingConfirm') }}
      </section>
    </section>
    <section v-else>
      <div class="flex justify-between items-center bg-b2c-red-300 text-white px-2">
          <h1 class="flex py-2 pl-2">
            {{$t('order.pending')}}
          </h1>
          <button class="font-bold pr-5 uppercase" @click="showPayment()" v-scroll-to="'#payment'">
            {{$t('order.pay')}}
          </button>
      </div>
      <div class="italic text-sm text-b2c-red-300 pt-1 pl-2">
        {{$t('order.message')}}
      </div>
    </section>
    <section class="flex justify-between items-stretch mt-10" v-if="!isPending && !isFailed">
      <div class="w-1/3 flex flex-col justify-between items-center mx-1 border-b-2" :class="isProcessed ? 'border-redish' : 'border-black'">
        <div class="w-1/3 flex justify-center">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 62.5 59.227" width="92%">
            <g id="Group_715" data-name="Group 715" transform="translate(-877.5 -369.773)">
              <g id="Group_697" data-name="Group 697" transform="translate(878 370.273)">
                <path id="Path_10" data-name="Path 10" d="M-908.028-805.139h35.573a1.913,1.913,0,0,1,1.861,1.861l1.862,33.422a1.848,1.848,0,0,1-1.862,1.861h-39.3a1.84,1.84,0,0,1-1.861-1.861l1.861-33.422a1.905,1.905,0,0,1,1.861-1.861Z" transform="translate(911.753 814.72)" fill="none" stroke="#464545" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                <path id="Path_11" data-name="Path 11" d="M-851.285-784.3a2.3,2.3,0,0,1,2.3,2.3,2.3,2.3,0,0,1-2.3,2.3,2.3,2.3,0,0,1-2.3-2.3,2.3,2.3,0,0,1,2.3-2.3Z" transform="translate(864.724 797.874)" fill="none" stroke="#464545" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                <path id="Path_12" data-name="Path 12" d="M-766.978-784.3a2.3,2.3,0,0,1,2.3,2.3,2.3,2.3,0,0,1-2.3,2.3,2.3,2.3,0,0,1-2.3-2.3,2.3,2.3,0,0,1,2.3-2.3Z" transform="translate(796.561 797.874)" fill="none" stroke="#464545" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                <path id="Path_13" data-name="Path 13" d="M-824.653-840.48v-6.864a7.858,7.858,0,0,0-7.833-7.833h0a7.855,7.855,0,0,0-7.833,7.833v6.864" transform="translate(853.998 855.176)" fill="none" stroke="#464545" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
              </g>
              <circle id="Ellipse_30" data-name="Ellipse 30" cx="17" cy="17" r="17" transform="translate(906 395)" fill="#fff"/>
              <g id="Group_696" data-name="Group 696" transform="translate(911.746 400.742)">
                <path id="Path_149" data-name="Path 149" d="M1321.047-225.494l4.68,4.68,7.487-7.487" transform="translate(-1315.901 235.789)" fill="none" stroke="#454645" stroke-miterlimit="10" stroke-width="1"/>
                <circle id="Ellipse_29" data-name="Ellipse 29" cx="11.231" cy="11.231" r="11.231" transform="translate(-0.001)" fill="none" stroke="#454645" stroke-miterlimit="10" stroke-width="1"/>
              </g>
            </g>
          </svg>
        </div>
        <div class="text-xs font-bold tracking-widest text-center mb-3 uppercase" :class="isProcessed ? 'text-redish': ''">
          {{ $t('order.status-processed') }}
        </div>
      </div>
      <div class="w-1/3 flex flex-col mx-1 justify-between items-center border-b-2" :class="isTransit ? 'border-redish' : 'border-black'">
        <div class="w-1/2 pt-2 flex justify-center">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 92.499 49.5" width="95%">
            <g id="Group_716" data-name="Group 716" transform="translate(-1125.501 -379.5)">
              <g id="Group_701" data-name="Group 701" transform="translate(576.001 147)">
                <g id="Group_698" data-name="Group 698" transform="translate(568.5 233)">
                  <path id="Path_150" data-name="Path 150" d="M595,241h9.8a2.466,2.466,0,0,1,2.037,1.077l4.2,7.557h1.233a2.419,2.419,0,0,1,2.467,2.724v8.372a2.47,2.47,0,0,1-2.467,2.47H609.8" transform="translate(-558 -231.133)" fill="none" stroke="#505050" stroke-miterlimit="10" stroke-width="1"/>
                  <path id="Path_151" data-name="Path 151" d="M582.267,265.067H602V233H565v32.067h7.4" transform="translate(-565 -233)" fill="none" stroke="#505050" stroke-miterlimit="10" stroke-width="1"/>
                  <path id="Path_152" data-name="Path 152" d="M608.871,259.94a4.945,4.945,0,1,1-4.944-4.922A4.934,4.934,0,0,1,608.871,259.94Z" transform="translate(-557.071 -227.862)" fill="none" stroke="#505050" stroke-miterlimit="10" stroke-width="1"/>
                  <path id="Path_153" data-name="Path 153" d="M580.889,259.94a4.944,4.944,0,1,1-4.944-4.922A4.934,4.934,0,0,1,580.889,259.94Z" transform="translate(-563.6 -227.862)" fill="none" stroke="#505050" stroke-miterlimit="10" stroke-width="1"/>
                  <line id="Line_171" data-name="Line 171" x2="4" transform="translate(37.5 32)" fill="none" stroke="#505050" stroke-miterlimit="10" stroke-width="1"/>
                  <path id="Path_154" data-name="Path 154" d="M597,249.233h8.633L608.1,248h2.467" transform="translate(-557.533 -229.5)" fill="none" stroke="#505050" stroke-miterlimit="10" stroke-width="1"/>
                </g>
                <g id="Group_699" data-name="Group 699" transform="translate(550 241.633)">
                  <line id="Line_172" data-name="Line 172" x2="22" transform="translate(0 0.367)" fill="none" stroke="#fff" stroke-linejoin="round" stroke-width="1"/>
                  <line id="Line_173" data-name="Line 173" x2="18" transform="translate(4 17.367)" fill="none" stroke="#fff" stroke-linejoin="round" stroke-width="1"/>
                  <line id="Line_174" data-name="Line 174" x2="16" transform="translate(10 8.367)" fill="none" stroke="#fff" stroke-linejoin="round" stroke-width="1"/>
                </g>
                <g id="Group_700" data-name="Group 700" transform="translate(550 240.4)">
                  <line id="Line_175" data-name="Line 175" x2="22" transform="translate(0 -0.4)" fill="none" stroke="#505050" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                  <line id="Line_176" data-name="Line 176" x2="18" transform="translate(4 17.6)" fill="none" stroke="#505050" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                  <line id="Line_177" data-name="Line 177" x2="16" transform="translate(10 8.6)" fill="none" stroke="#505050" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                </g>
              </g>
              <circle id="Ellipse_31" data-name="Ellipse 31" cx="17" cy="17" r="17" transform="translate(1184 395)" fill="#fff"/>
              <g id="Group_702" data-name="Group 702" transform="translate(1189.746 400.742)">
                <path id="Path_149" data-name="Path 149" d="M1321.047-225.494l4.68,4.68,7.487-7.487" transform="translate(-1315.901 235.789)" fill="none" stroke="#454645" stroke-miterlimit="10" stroke-width="1"/>
                <circle id="Ellipse_29" data-name="Ellipse 29" cx="11.231" cy="11.231" r="11.231" transform="translate(-0.001)" fill="none" stroke="#454645" stroke-miterlimit="10" stroke-width="1"/>
              </g>
            </g>
          </svg>
        </div>
        <div class="text-xs font-bold tracking-widest text-center mb-3 uppercase" :class="isTransit ? 'text-redish' : ''">
          {{ $t('order.status-transit') }}
        </div>
      </div>
      <div class="w-1/3 flex flex-col mx-1 justify-between items-center border-b-2" :class="isDelivered ? 'border-redish' : 'border-black'">
        <div class="w-1/3 pt-2 flex justify-center">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 58.5 50.5" width="90%">
            <g id="Group_717" data-name="Group 717" transform="translate(-1410.5 -378.5)">
              <g id="Group_703" data-name="Group 703" transform="translate(791 268)">
                <line id="Line_178" data-name="Line 178" y2="20" transform="translate(639 130)" fill="none" stroke="#505050" stroke-linejoin="round" stroke-width="1"/>
                <path id="Path_155" data-name="Path 155" d="M639,111l-19,9v1l19,9,19-9v-1Z" fill="none" stroke="#505050" stroke-linejoin="round" stroke-width="1"/>
                <line id="Line_179" data-name="Line 179" x1="19.778" y1="9.368" transform="translate(629.222 115.632)" fill="none" stroke="#505050" stroke-linejoin="round" stroke-width="1"/>
                <path id="Path_156" data-name="Path 156" d="M620,121v20l19,9,19-10.391V121" fill="none" stroke="#505050" stroke-linejoin="round" stroke-width="1"/>
              </g>
              <circle id="Ellipse_32" data-name="Ellipse 32" cx="17" cy="17" r="17" transform="translate(1435 395)" fill="#fff"/>
              <g id="Group_704" data-name="Group 704" transform="translate(1440.746 400.742)">
                <path id="Path_149" data-name="Path 149" d="M1321.047-225.494l4.68,4.68,7.487-7.487" transform="translate(-1315.901 235.789)" fill="none" stroke="#454645" stroke-miterlimit="10" stroke-width="1"/>
                <circle id="Ellipse_29" data-name="Ellipse 29" cx="11.231" cy="11.231" r="11.231" transform="translate(-0.001)" fill="none" stroke="#454645" stroke-miterlimit="10" stroke-width="1"/>
              </g>
            </g>
          </svg>
        </div>
        <div class="text-xs font-bold tracking-widest text-center mb-3 uppercase" :class="isDelivered ? 'text-redish' : ''">
          {{ $t('order.status-delivered') }}
        </div>
      </div>
    </section>
    <order-header :order="order" :isPending="isPending" />
    <order-summary :lines="order.details" />
    <order-totals :order="order" :showBack="!pay" />
    <order-payment id="payment" v-if="pay" :order="order" @paid="setPaid()" @updated="fetchOrder" />

    <section class="md:mt-32 mt-20" v-if="false">
      <div class="flex flex-col">
        <svg xmlns="http://www.w3.org/2000/svg" width="10%" viewBox="0 0 76.233 38">
          <g id="Group_705" data-name="Group 705" transform="translate(-549.5 -232.5)">
            <g id="Group_698" data-name="Group 698" transform="translate(568.5 233)">
              <path id="Path_150" data-name="Path 150" d="M595,241h9.8a2.466,2.466,0,0,1,2.037,1.077l4.2,7.557h1.233a2.419,2.419,0,0,1,2.467,2.724v8.372a2.47,2.47,0,0,1-2.467,2.47H609.8" transform="translate(-558 -231.133)" fill="none" stroke="#505050" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Path_151" data-name="Path 151" d="M582.267,265.067H602V233H565v32.067h7.4" transform="translate(-565 -233)" fill="none" stroke="#505050" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Path_152" data-name="Path 152" d="M608.871,259.94a4.945,4.945,0,1,1-4.944-4.922A4.934,4.934,0,0,1,608.871,259.94Z" transform="translate(-557.071 -227.862)" fill="none" stroke="#505050" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Path_153" data-name="Path 153" d="M580.889,259.94a4.944,4.944,0,1,1-4.944-4.922A4.934,4.934,0,0,1,580.889,259.94Z" transform="translate(-563.6 -227.862)" fill="none" stroke="#505050" stroke-miterlimit="10" stroke-width="1"/>
              <line id="Line_171" data-name="Line 171" x2="4" transform="translate(37.5 32)" fill="none" stroke="#505050" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Path_154" data-name="Path 154" d="M597,249.233h8.633L608.1,248h2.467" transform="translate(-557.533 -229.5)" fill="none" stroke="#505050" stroke-miterlimit="10" stroke-width="1"/>
            </g>
            <g id="Group_699" data-name="Group 699" transform="translate(550 241.633)">
              <line id="Line_172" data-name="Line 172" x2="22" transform="translate(0 0.367)" fill="none" stroke="#fff" stroke-linejoin="round" stroke-width="1"/>
              <line id="Line_173" data-name="Line 173" x2="18" transform="translate(4 17.367)" fill="none" stroke="#fff" stroke-linejoin="round" stroke-width="1"/>
              <line id="Line_174" data-name="Line 174" x2="16" transform="translate(10 8.367)" fill="none" stroke="#fff" stroke-linejoin="round" stroke-width="1"/>
            </g>
            <g id="Group_700" data-name="Group 700" transform="translate(550 240.4)">
              <line id="Line_175" data-name="Line 175" x2="22" transform="translate(0 -0.4)" fill="none" stroke="#505050" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
              <line id="Line_176" data-name="Line 176" x2="18" transform="translate(4 17.6)" fill="none" stroke="#505050" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
              <line id="Line_177" data-name="Line 177" x2="16" transform="translate(10 8.6)" fill="none" stroke="#505050" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
            </g>
          </g>
        </svg>
        <div class="text-xs font-bold py-2">
          {{ $t('order.tracking-info') }}
        </div>
        <div class="text-xs py-2" :class="fontHairline()">
          {{ $t('order.tracking-sentence') }}
          <a class="font-bold underline text-blackish" :href="order.tracking_url">{{ $t('order.tracking-here') }}</a>.
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import OrderHeader from '@/components/profile/OrderHeader.vue';
import OrderSummary from '@/components/profile/OrderSummary.vue';
import OrderTotals from '@/components/profile/OrderTotals.vue';
import OrderPayment from '@/components/profile/OrderPayment.vue';
import { getSingleOrder } from '@/services/OrdersService';

import { mapGetters } from 'vuex';

export default {
  metaInfo() {
    const title = this.$t('titles.orders');
    return {
      title,
      meta: [
        {
          name: 'description',
          content: 'Your orders',
        },
      ],
    };
  },

  data() {
    return {
      order: {},

      pay: false,
    };
  },

  computed: {
    ...mapGetters({
      changedLocale: 'auth/changedLocale',
      updatedOrder: 'cart/updatedOrder',
    }),
    isProcessed() {
      return this.order.current_state === 'in_work';
    },

    isTransit() {
      return this.order.current_state === 'shipped';
    },

    isDelivered() {
      return this.order.current_state === 'delivered';
    },

    isPending() {
      return this.order.current_state === 'pending';
    },
    isFailed() {
      return this.order.current_state === 'failed_payment';
    },
  },

  watch: {
    changedLocale() {
      this.fetchOrder();
    },

    updatedOrder() {
      if (this.updatedOrder) {
        this.fetchOrder();
        this.$store.dispatch('cart/updatedOrder');
      }
    },
  },

  components: {
    OrderHeader,
    OrderSummary,
    OrderTotals,
    OrderPayment,
  },

  mounted() {
    this.fetchOrder();
  },

  methods: {
    fetchOrder() {
      getSingleOrder(this.$route.params.order_no)
        .then(({ data }) => {
          this.order = data;
        }).catch(() => {
          this.createNotification('error', `${this.$t('notifications.errorReload')}`);
        });
    },

    showPayment() {
      this.pay = true;
    },

    setPaid() {
      this.pay = false;
      this.fetchOrder();
    },
  },
};
</script>
